// the ranges are multiplied by two in relation to the real price table
export default [
  [-Infinity, 0.0],
  [14, 253.89],
  [28, 310.56],
  [42, 345.30],
  [60, 401.08],
  [80, 453.05],
  [100, 516.75],
  [120, 586.18],
  [140, 682.41],
  [160, 763.83],
  [180, 882.14],
  [200, 942.93],
  [220, 998.37],
  [240, 1086.44],
  [260, 1202.13],
  [280, 1272.80],
  [300, 1347.63],
  [Infinity, 1426.87],
];
